import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialSlideshareIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialSlideshare",
    children: /*#__PURE__*/_jsx("path", {
      d: "M5.56 1C3.65 1 2.08 2.57 2.08 4.48V14c-.33-.31-.6-.57-.73-.71l-.08-.08c-.13-.12-.38-.19-.54-.19-.48 0-.74.25-.74.49 0 .57.22 1.02.27 1.13.71 1.74 3.88 5.1 6.28 6-.73 1.46-.73 5.09-.73 5.09 0 3.12 2.34 5.71 5.54 5.82h1.04c1.6-.11 2.88-1.39 2.87-2.99v-6.08c.29.12.83.25 1.46.3v5.89a2.88 2.88 0 0 0 2.88 2.88h1.1c3.17 0 5.47-2.57 5.47-5.82 0 0 0-3.64-.73-5.09 2.21-.92 5.24-3.98 6.24-5.82.06-.11.3-.74.3-1.45 0-.17-.16-.57-.64-.57-.34 0-.57.3-.57.3-.16.16-.47.48-.88.86V4.48c0-1.91-1.57-3.48-3.48-3.48zm0 1.39h20.87c1.16 0 2.09.93 2.09 2.09v10.65c-1.65 1.26-4.01 2.61-6.7 2.61H18.6c-1.06 0-1.87.9-1.87 1.87v.57c-.64-.35-1.37-.97-2.18-1.93 0 0-.32-.51-1.18-.51h-3.18c-2.75 0-5.09-1.34-6.7-2.57V4.48c0-1.16.93-2.09 2.09-2.09Zm5.22 6.26a3.83 3.83 0 1 0 0 7.66 3.83 3.83 0 0 0 0-7.66m10.44 0a3.83 3.83 0 1 0 0 7.66 3.83 3.83 0 0 0 0-7.66"
    })
  }));
};
SocialSlideshareIcon.displayName = 'SocialSlideshareIcon';